var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_349",
  "data-name": "Ellipse 349",
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#c84222"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_5649",
  "data-name": "Group 5649",
  transform: "translate(-2487.75 -294.866)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_364",
  "data-name": "Path 364",
  d: "M0,0H10",
  transform: "translate(2492.214 306.402) rotate(-45)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1236",
  "data-name": "Path 1236",
  d: "M0,0H10",
  transform: "translate(2499.285 306.402) rotate(-135)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}))));
export default __webpack_public_path__ + "static/media/circle-cross2.2c44b0cb.svg";
export { SvgComponent as ReactComponent };